import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MaskLines, Reveal } from "@/components/Primitives";
import { usePageMeta } from "@/lib/motion";

export default function NotFound() {
  usePageMeta("404 — Lost in the Void · Hades", "This page does not exist.");
  return (
    <section className="relative flex min-h-[100svh] items-center overflow-hidden pt-24" data-testid="not-found-page">
      <div className="container-x relative">
        <Reveal><span className="eyebrow">Error 404 / Lost in the Void</span></Reveal>
        <MaskLines as="h1" onLoad delay={0.1} lines={["This path leads", "nowhere."]} className="mt-8 font-serif text-6xl font-light leading-[0.95] text-ivory sm:text-8xl" />
        <Reveal as="p" delay={0.3} className="mt-8 max-w-md text-ash">The page you are looking for has been moved, renamed, or never existed.</Reveal>
        <Reveal delay={0.45} className="mt-12">
          <Link to="/" className="btn btn-primary" data-testid="not-found-home-btn"><ArrowLeft size={16} /> Return Home</Link>
        </Reveal>
      </div>
    </section>
  );
}
